import type { GridSortModel } from "@mui/x-data-grid-pro"
import { ALL_GEO } from "./types"

/** Selectable rows-per-page options for the signals grid. */
export const PRECOMPUTED_PAGE_SIZE_OPTIONS = [25, 50, 100]
export const DEFAULT_PRECOMPUTED_PAGE_SIZE = 25

/**
 * Row cap for the "all filtered results" query that feeds the v2 map and rail
 * summary (aggregation strip / Top Diseases) — these reflect the whole filtered
 * set rather than the grid's current page. Generous enough to cover real
 * filtered sets without fetching unbounded data.
 */
export const PRECOMPUTED_MAP_RESULT_LIMIT = 1000

/** Normalized (lowercased) names the GDELT feed may use for the United States. */
const US_COUNTRY_NAMES = new Set([
  "united states",
  "united states of america",
  "us",
  "u.s.",
  "u.s.a.",
  "usa",
  "america",
])

export const GDELT_US_STATE_TOOLTIP =
  "Narrows to US state-level clusters. Disabled when another country is selected."

export const GDELT_DATE_RANGE_TOOLTIP =
  "Shows clusters with at least one member article published in this range."

/**
 * True when a non-US country is selected (which makes US State mutually
 * exclusive). Matches the US case-insensitively across the name variants the
 * feed uses, so selecting "United States" (or "United States of America") keeps
 * the US State filter enabled.
 */
export const isNonUsCountrySelected = (country: string) =>
  country !== ALL_GEO && !US_COUNTRY_NAMES.has(country.trim().toLowerCase())

export const PRECOMPUTED_GDELT_TAB_LABEL = "Public/Commercial"

export const DEFAULT_GDELT_SORT_MODEL: GridSortModel = [
  { field: "publish_time", sort: "desc" },
  { field: "impact_score", sort: "desc" },
  { field: "cluster_count", sort: "desc" },
]

export const DEFAULT_NWSS_SORT_MODEL: GridSortModel = [
  { field: "publish_time", sort: "desc" },
]
